module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/main-categories-icons/22-2ef561c2e8febeeb7d41ed476b7fcb6d.svg";